"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Super/SuperMoveUserToAnotherOrgModal.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');
var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _log = require('shared/log');




var _formHelpers = require('web/screens/Super/formHelpers');










/* convert our textfield into an array of user keys */
const toUserKeysArray = (userKeys) =>
  // SAFETY: typed in by a super user; the backend validates each key.
  userKeys.split(',').map(v => v.trim()).filter(v => v !== '') 

const SuperMoveUserToAnotherOrgModal = ({ open, onClose, users, currentOrgKey }) => {
  const [userKeys, setUserKeys] = _react.useState.call(void 0, "")
  const [fromOrgKey, setFromOrgKey] = _react.useState.call(void 0, "")
  const [fromOrg, setFromOrg] = _react.useState({})
  const [toOrgKey, setToOrgKey] = _react.useState.call(void 0, "")
  const [toOrg, setToOrg] = _react.useState({})

  const [loadingUserInfo, setLoadingUserInfo] = _react.useState.call(void 0, false)
  const [hasUserInfo, setHasUserInfo] = _react.useState.call(void 0, false)
  // The message of a failed lookup or a failed SuperMoveUsers.
  const [error, setError] = _react.useState(null)

  // The class read this.state and this.props when a request resolved, not
  // when it was sent. Closing the modal meanwhile resets the keys, so the
  // lookup then reports "Missing People", as before.
  // Synced after each commit, so it holds the committed values, like this.state.
  const latest = _react.useRef.call(void 0, { fromOrgKey, toOrgKey, onClose })
  _react.useLayoutEffect.call(void 0, () => {
    latest.current = { fromOrgKey, toOrgKey, onClose }
  })

  const resetForm = () => {
    setFromOrgKey(currentOrgKey)
    setToOrgKey("")
    setUserKeys("")
    setLoadingUserInfo(false)
    setHasUserInfo(false)
    setError(null)
  }

  // componentDidUpdate, which ran before paint: fill in the default org key
  // when the modal opens, and reset the form when it closes.
  const prevOpen = _react.useRef.call(void 0, open)
  _react.useLayoutEffect.call(void 0, () => {
    if (open && !prevOpen.current) {
      setFromOrgKey(currentOrgKey)
    }
    if (!open && prevOpen.current) {
      resetForm()
    }
    prevOpen.current = open
  }, [open]) // eslint-disable-line react-hooks/exhaustive-deps

  const onSubmit = () => {
    setLoadingUserInfo(true)
    Promise.all([
      // SAFETY: typed in by a super user; GetOrgs validates them.
      _actions2.default.getOrgs({ OrgKeys: [fromOrgKey , toOrgKey ] }),
      _actions2.default.getUsers({ UserKeys: toUserKeysArray(userKeys) }),
    ]).then(res => {
      setHasUserInfo(true)
      const orgsResponse = res[0]
      const userResponse = res[1]

      if (!orgsResponse.Orgs || !userResponse.Users) {
        throw new Error("Bad Keys used")
      }

      // SAFETY: typed in by a super user; a key GetOrgs lacks reads undefined.
      const nextFromOrg = orgsResponse.Orgs[latest.current.fromOrgKey ]
      // SAFETY: as above.
      const nextToOrg = orgsResponse.Orgs[latest.current.toOrgKey ]

      if (!nextFromOrg || !nextToOrg) {
        throw new Error("Missing People")
      }

      setFromOrg(nextFromOrg)
      setToOrg(nextToOrg)
    }).catch(err => {
      _log.log.error(err)
      setError(_formHelpers.errorMessage.call(void 0, err))
    })
  }

  const onConfirm = () => {
    _client2.default.send('SuperMoveUsers', {
      // SAFETY: typed in by a super user; the backend validates them.
      FromOrgKey: fromOrgKey ,
      // SAFETY: as above.
      ToOrgKey: toOrgKey ,
      UserKeys: toUserKeysArray(userKeys),
      MoveConversations: true,
    }).then(() => {
      latest.current.onClose()
    }).catch((err) => {
      _log.log.error(err)
      setError(_formHelpers.errorMessage.call(void 0, err))
    })
  }

  const onChange = (id, val) => {
    if (loadingUserInfo) {
      return
    }

    if (id === 'userKeys') setUserKeys(val)
    else if (id === 'fromOrgKey') setFromOrgKey(val)
    else setToOrgKey(val)
  }

  const loadAllUsers = () => {
    const userKeysArr = users.map(u => u.UserKey).join(', ')
    setUserKeys(userKeysArr)
  }

  const numUsers = toUserKeysArray(userKeys).length
  const enterKeysDialog = (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_Form.InputSectionWrapper, { title: "UserKey(s), separated by a comma"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 136}}
        , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 137}},  numUsers > 0 && `${numUsers} loaded` )
        , _react2.default.createElement(_Form.TextInput, {
          value: userKeys,
          onChange: e => onChange('userKeys', e.target.value),
          placeholder: "Enter userKey (e.g. ab16e2ce-5e07-4178-915f-19182bf7eeee)"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 138}}
        )
      )
      , _react2.default.createElement('br', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 144}} ), _react2.default.createElement('br', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 144}} )
      , _react2.default.createElement(_Form.Button, { onClick: loadAllUsers, __self: this, __source: {fileName: _jsxFileName, lineNumber: 145}}, "Load all userKeys"  )

      , _react2.default.createElement(_Form.InputSectionWrapper, { title: "Current Organization Key"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 147}}
        , _react2.default.createElement(_Form.TextInput, {
          value: fromOrgKey,
          onChange: e => onChange('fromOrgKey', e.target.value),
          placeholder: "Enter current user org key (e.g. f4a6719d-856e-48c3-8a4a-5e05de6ed085)"      , __self: this, __source: {fileName: _jsxFileName, lineNumber: 148}}
        )
      )

      , _react2.default.createElement(_Form.InputSectionWrapper, { title: "Target Organization Key"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 155}}
        , _react2.default.createElement(_Form.TextInput, {
          value: toOrgKey,
          onChange: e => onChange('toOrgKey', e.target.value),
          placeholder: "Enter desired org key (e.g. defd6a4f-5f64-4eb5-a665-7276b6719871)"     , __self: this, __source: {fileName: _jsxFileName, lineNumber: 156}}
        )
      )

      , _react2.default.createElement(_Modal.ModalControls, {
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: onClose,
        primaryBtnLabel: "Move User(s)" ,
        isPrimaryLoading: loadingUserInfo,
        onPrimaryBtnClick: onSubmit, __self: this, __source: {fileName: _jsxFileName, lineNumber: 163}}
      )
    )
  )

  const confirmMoveDialog = (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_Modal.ModalSubtitle, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 175}}, "Are you sure you want to move users from"
                , ' '
        , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 177}}, fromOrg.Name), " to" , ' '
        , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 178}}, toOrg.Name), "?"
      )
      , _react2.default.createElement(_Modal.ModalControls, {
        secondaryBtnLabel: "Cancel",
        onSecondaryBtnClick: onClose,
        primaryBtnLabel: "Confirm",
        onPrimaryBtnClick: onConfirm, __self: this, __source: {fileName: _jsxFileName, lineNumber: 180}}
      )
    )
  )

  const errorDialog = (
    _react2.default.createElement('div', { style: { color: 'red' }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 190}},  error )
  )

  let content = null
  if (error !== null) content = errorDialog
  else if (hasUserInfo) content = confirmMoveDialog
  else content = enterKeysDialog

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: open,
      onClose: onClose,
      title: "Move user to another organization"    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 199}}

      ,  content 
    )
  )
}

exports. default = SuperMoveUserToAnotherOrgModal
